import { httpClient } from "@services/api/httpClient";

export async function createOffer(data: any) {
  const response = await httpClient.post(`/offer/create`, data);
  return response.data;
}